/**
 * Roadmap Component
 * 
 * Displays a 3-step progress indicator:
 * - Step 1: 対象者の追加 (Add Participants)
 * - Step 2: 書類設定 (Document Settings)
 * - Step 3: 送信内容確認 (Confirm Send Content)
 * 
 * Active step is highlighted in blue, inactive steps are grey.
 */
import React from 'react';
import './Roadmap.css';

export interface RoadmapProps {
  /** Current active step (1, 2, or 3) */
  currentStep: number;
}

const Roadmap: React.FC<RoadmapProps> = ({ currentStep }) => {
  const steps = [
    { number: 1, label: '対象者の追加' },
    { number: 2, label: '書類設定' },
    { number: 3, label: '送信内容確認' },
  ];

  return (
    <div className="roadmap">
      {steps.map((step, index) => {
        const isActive = step.number === currentStep;
        const isCompleted = step.number < currentStep;
        const isLast = index === steps.length - 1;

        return (
          <React.Fragment key={step.number}>
            <div className="roadmap__step">
              <div
                className={`roadmap__circle ${isActive ? 'roadmap__circle--active' : ''} ${isCompleted ? 'roadmap__circle--completed' : ''}`}
              >
                {step.number}
              </div>
              <div
                className={`roadmap__label ${isActive ? 'roadmap__label--active' : ''} ${isCompleted ? 'roadmap__label--completed' : ''}`}
              >
                {step.label}
              </div>
            </div>
            {!isLast && (
              <div
                className={`roadmap__line ${isActive || isCompleted ? 'roadmap__line--active' : ''}`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Roadmap;
